import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=3814216c&scoped=true"
import script from "./TaskTable.vue?vue&type=script&lang=js"
export * from "./TaskTable.vue?vue&type=script&lang=js"
import style0 from "./TaskTable.vue?vue&type=style&index=0&id=3814216c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3814216c",
  null
  
)

export default component.exports